<template>
  <div class="content">
    <div class="info-card-wrap">
      <!-- 剩余余额卡片 -->
      <div class="info-card balance-card">
        <div class="card-text">我的下级数量：{{ total }}</div>
      </div>
    </div>
    <!-- 表格卡片 -->
    <div class="table-card">
      <el-table
        :data="tableData"
        border
        stripe
        size="medium"
        style="width: 100%"
      >
        <el-table-column prop="id" label="序号" width="80" align="center" />
        <el-table-column
          prop="level_text"
          label="采购版本"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column label="联系人" align="center" width="180">
          <template slot-scope="scope">
            姓名：{{ scope.row.nickname }} <br />
            电话：{{ scope.row.phone }}<br />
            微信：{{ scope.row.wx }}<br />
            地址：{{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="剩余余额" align="center" width="180">
          <template slot-scope="scope">
            {{
              Number(scope.row.balance_total) - Number(scope.row.balance_used)
            }}
          </template>
        </el-table-column>
        <el-table-column label="剩余学习时长" align="center" width="180">
          <template slot-scope="scope">
            {{
              Number(scope.row.time_total) - Number(scope.row.time_used)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column prop="create_at" label="时间" align="center" />
      </el-table>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { balance, userInfo, subList } from "@/api/api";

export default {
  name: "index",
  data() {
    return {
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      info: {},
    };
  },
  mounted() {
    this.subList();
    this.userInfo();
  },
  computed: {
    // remainMonth() {
    //   const remain = this.info.time_total - this.info.time_used
    //   return Math.floor(remain / 30) || 0
    // }
  },
  methods: {
    userInfo() {
      userInfo().then((res) => {
        this.info = res.data;
      });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.subList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.subList();
    },
    subList() {
      let params = {
        page: this.page,
        limit: this.limit,
      };
      subList(params).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.page.total;
      });
    },
  },
};
</script>

<style scoped lang="less">
// 表格卡片样式
.table-card {
  margin-top: 20px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  /*box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);*/
  border: 1px solid #f1f1f1;
}

// 分页样式
.page {
  margin-top: 20px;
  text-align: right;
}

// 外层容器：两个卡片横向排列、间距自适应
.info-card-wrap {
  display: flex;
  gap: 30px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  // 通用卡片样式 完全匹配截图深蓝色圆角
  .info-card {
    flex: 1;
    min-width: 320px;
    background: #2f3ced;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 24px;

    // 图标样式
    .card-icon {
      width: 50px;
      height: 50px;
    }

    // 文字样式 白色居中
    .card-text {
      font-size: 20px;
      color: #ffffff;
      font-weight: 500;
    }
  }
}
</style>
